import crypto from 'crypto';

export const idGenerator = (): string => {
	try {
		const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		// The largest byte value that is a multiple of `char.length`.
		const maxMultiple = Math.floor(256 / chars.length) * chars.length;
		if (!(0 < maxMultiple && maxMultiple < 256))
			throw new Error(`Expect maxMultiple to be (0, 256), but got ${maxMultiple}`);

		let autoId = '';
		const targetLength = 20;
		while (autoId.length < targetLength) {
			const bytes = crypto.randomBytes(40);
			// Only accept values that are [0, maxMultiple), this ensures they can
			// be evenly mapped to indices of `chars` via a modulo operation.
			for (let i = 0; i < bytes.length; ++i)
				if (autoId.length < targetLength && bytes[i] < maxMultiple) autoId += chars.charAt(bytes[i] % chars.length);
		}
		if (autoId.length !== targetLength) throw new Error(`Invalid auto ID: ${autoId}`);
		return autoId;
	} catch (error) {
		console.log('Error while creating unique Id', error);
		return idGenerator();
	}
};
